<template>
  <div :class="$style['payList__installment__table']" :style="{ width: isPrepaid ? '100%' : '50%', padding: isPrepaid ? '' : '36px' }">
    <div v-if="dataLoading">
      <p>多次付款期數：{{ installmentOrderClone.installments.length }}期</p>
      <el-table style="width: 100%;" :data="installmentOrderClone.installments" :class="{ [$style.detailTable]: true, [$style.fullWidth]: true }">
        <el-table-column label="期數／金額" min-width="10">
          <template slot-scope="scope">
            <div>
              <p v-if="scope.row.paymentStatus === 'PAID'" style="color: #12C494;">已付款</p>
              <p v-else class="text-danger">未付款</p>
            </div>
            <p>{{ `第${scope.$index + 1}期付款NT$${scope.row.amount}` }}</p>
          </template>
        </el-table-column>

        <el-table-column label="付款方式" min-width="10">
          <template slot-scope="scope">
            <el-select v-model="scope.row.paymentMethod" class="is-round is-border" :disabled="scope.row.paymentStatus === 'PAID'">
              <el-option v-for="(method, index) in paymentMethodsList" :key="`method-${index}`" :value="method.value" :label="method.name"></el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column :label="`付款`" min-width="6" prop="prices">
          <template slot-scope="scope">
            <el-button type="primary" round class="w-100 px-1" :disabled="scope.row.paymentStatus === 'PAID'" @click="openPayingDialog(scope.$index)">確認付款</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-button type="primary" round class="w-100 mt-4" @click="closeDialogAndDrawer">完成</el-button>
    <el-dialog title="付款確認" :visible.sync="payingDialogVisible" width="30%" :top="'0'" :append-to-body="true" @close="payingDialogVisible = false">
      <el-form v-if="isCreditOrAtm" :model="selectInstallmentData">
        <el-form-item v-if="selectInstallmentData.paymentMethod === 'StoreCredit'" class="mb-0" prop="note" label="信用卡末四碼">
          <el-input v-model="selectInstallmentData.note" maxlength="4" minlength="4" placeholder="請輸入"></el-input>
        </el-form-item>
        <el-form-item v-if="selectInstallmentData.paymentMethod === 'Atm'" class="mb-0" prop="note" label="匯款帳號末五碼">
          <el-input v-model="selectInstallmentData.note" maxlength="5" minlength="5" placeholder="請輸入"></el-input>
        </el-form-item>
      </el-form>
      <div v-else class="text-center mb-3">是否確認付款？</div>
      <span slot="footer" class="dialog-footer d-flex">
        <el-button class="w-50" round :loading="btnLoading" @click="payingDialogVisible = false">取消</el-button>
        <el-button class="w-50" type="primary" round :loading="btnLoading" @click="singleInstallmentStore">確定付款</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep'

export default {
  props: {
    installmentOrder: {
      type: Object,
      default: () => {},
    },
    isPrepaid: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      installmentOrderClone: {}, // 從prop深拷貝的資料，方便操作
      payingDialogVisible: false,
      selectInstallmentData: {}, // 使用者點選付款的資料，用來送出api
      btnLoading: false,
    }
  },
  computed: {
    isCreditOrAtm() {
      if (Object.keys(this.selectInstallmentData).length) {
        const { paymentMethod } = this.selectInstallmentData
        return paymentMethod === 'StoreCredit' || paymentMethod === 'Atm'
      }
      return null
    },
    dataLoading() {
      return Boolean(this.installmentOrderClone?.installments?.length)
    },
    // 中租付款只對特定商家開放
    hasChailease() {
      return this.$store.state.merchant.cached.alias === 'naturalpan'
    },
    paymentMethodsList() {
      const arr = [
        {
          name: '現金支付',
          value: 'Cash',
        },
        {
          name: '線下匯款',
          value: 'Atm',
        },
        {
          name: '現場信用卡',
          value: 'StoreCredit',
        },
        {
          name: '儲值金抵扣',
          value: 'Deposit',
        },
        {
          name: '不指定付款方式',
          value: '',
        },
        {
          name: 'Line Pay',
          value: 'StoreLinePay',
        },
      ]
      const chailease = {
        name: '中租零卡分期',
        value: 'Chailease',
      }

      if (this.hasChailease) arr.push(chailease)
      return arr
    },
  },
  watch: {
    installmentOrder: {
      handler(nvl) {
        this.installmentOrderClone = cloneDeep(nvl)
        const { installments } = this.installmentOrderClone
        if (installments) {
          this.installmentOrderClone.installments.forEach((item) => {
            if (item.paymentMethod === null && item.paymentStatus === 'PAID') item.paymentMethod = ''
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    closeDialogAndDrawer() {
      this.$emit('close')
    },
    async singleInstallmentStore() {
      let data = {
        installments: [],
        type: this.isPrepaid ? 'PrepaidOrder' : 'OrderContainer',
        uuid: this.installmentOrderClone.uuid || this.installmentOrderClone.id,
      }
      this.selectInstallmentData.paymentStatus = 'PAID'
      data.installments.push(this.selectInstallmentData)

      await this.tryToPaySingleInstallment(data)
    },
    async tryToPaySingleInstallment(data) {
      try {
        this.btnLoading = true
        const result = await this.$store.dispatch('order/installmentStore', data)
        if (result.code === 200) {
          this.$message({
            message: '付款成功',
            type: 'success',
          })
          const index = this.installmentOrderClone.installments.findIndex((item) => item.no === data.installments[0].no)
          if (index !== -1) this.installmentOrderClone.installments[index].paymentStatus = 'PAID'
        }
      } catch (err) {
        console.error(err)
        this.btnLoading = false
        this.payingDialogVisible = false
        await this.$alert(`付款錯誤，即將離開付款頁面`, {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
        this.$emit('close')
      } finally {
        this.btnLoading = false
        this.payingDialogVisible = false
      }
    },
    openPayingDialog(index) {
      // 不允許跳單付款
      if (index > 0) {
        for (let i = 0; i < index; i++) {
          if (this.installmentOrderClone.installments[i].paymentStatus === 'UNPAID') {
            this.$message.error(`請先支付第${i + 1}期款項`)
            return
          }
        }
      }
      if (this.installmentOrderClone.installments[index].paymentMethod === null) {
        this.$message.error('請選擇付款方式')
        return
      }

      this.payingDialogVisible = true
      this.selectInstallmentData = cloneDeep(this.installmentOrderClone.installments[index])
    },
  },
}
</script>

<style module lang="scss">
.payList__installment__table {
  background-color: #fff;
  border-radius: 4px;
}

.fullWidth {
  :global {
    .el-table__header {
      width: 100% !important;
    }

    .el-table__empty-block {
      width: 100% !important;
    }

    .el-table__body {
      width: 100% !important;
    }
  }
}

.detailTable {
  &::before {
    height: 0;
    display: none;
  }

  :global {
    .goods-img {
      width: 100%;
    }

    .goods-info {
      p {
        margin: 0;
      }
    }

    .goods-amount {
      max-width: 100px;
    }

    .el-table__row {
      background-color: #ffffff;
    }

    .el-table__header-wrapper {
      th {
        background-color: #e5e7eb;
      }
      tr th .cell {
        display: flex;
        justify-content: center;
      }
      tr th .cell {
        justify-content: start;
      }
    }

    .el-table__footer-wrapper {
      tr td {
        background-color: #ffffff !important;
      }
      tr td:nth-child(3) .cell {
        text-align: center;
      }
    }

    th {
      border: none !important;
    }

    .close-icon {
      font-size: 20px;
      cursor: pointer;
    }
  }
}
</style>
